import React from 'react';
import { TERMS_OF_SERVICE_URL } from '../../utils/redirect-const';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { LABEL_BLACK } from '../../utils/color-const';

const Text = styled(Typography)(({ theme }) => ({
  fontSize: 12,
}));

const AgreeToTermsInfo = () => (
  <Text>
    Klikając "Zarejestruj" zgadzasz się na{' '}
    <Link
      rel="noopener noreferrer"
      to={TERMS_OF_SERVICE_URL}
      sx={{ color: LABEL_BLACK }}
    >
      Warunki Użytkowania
    </Link>
  </Text>
);

export default AgreeToTermsInfo;
